import React from "react";
import { Modal, Button, Form, Input, Select } from "antd";
import Wrapper from "./style";
import { customBaseUrl, httpPost } from "../../../store/http";
import { hideLoader, showLoader } from "../../../utils/loader";
import { NotificationManager } from "react-notifications";

const { Option } = Select;

const CreateGLAccountModal = ({ showModal, hideModal, onSuccess }) => {
    const [form] = Form.useForm();

    const handleCreate = async (values) => {
        showLoader();
        try {
            // Using false for second arg as per user's recent preference in FeesSettings.jsx
            const res = await httpPost(`${customBaseUrl.tranv2}/api/v1/gl-accounts`, values, false, null, false);
            if (res?.success ?? res?.status) {
                NotificationManager.success('GL Account created successfully!');
                hideModal();
                form.resetFields();
                if (onSuccess) onSuccess();
            } else {
                NotificationManager.error(res?.message || 'Failed to create GL account.');
            }
        } catch (error) {
            NotificationManager.error('An error occurred while creating GL account.');
        } finally {
            hideLoader();
        }
    };

    return (
        <Modal
            visible={showModal}
            title="Create GL Account"
            onCancel={hideModal}
            footer={null}
            centered
            width={600}
        >
            <Wrapper>
                <div className="title" style={{ marginBottom: 24, fontSize: 18, fontWeight: 700 }}>New GL Account</div>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleCreate}
                    initialValues={{
                        accountType: 'ASSET',
                        accountClass: 'DETAIL',
                        normalBalance: 'DEBIT'
                    }}
                >
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="Account Code"
                            name="accountCode"
                            rules={[{ required: true, message: 'Account code is required' }]}
                        >
                            <Input placeholder="e.g. 10010001" />
                        </Form.Item>

                        <Form.Item
                            label="Account Name"
                            name="accountName"
                            rules={[{ required: true, message: 'Account name is required' }]}
                        >
                            <Input placeholder="e.g. Cash at Bank" />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
                        <Form.Item
                            label="Account Type"
                            name="accountType"
                            rules={[{ required: true }]}
                        >
                            <Select placeholder="Select Type">
                                <Option value="ASSET">ASSET</Option>
                                <Option value="LIABILITY">LIABILITY</Option>
                                <Option value="EQUITY">EQUITY</Option>
                                <Option value="INCOME">INCOME</Option>
                                <Option value="EXPENSE">EXPENSE</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Account Class"
                            name="accountClass"
                            rules={[{ required: true }]}
                        >
                            <Select placeholder="Select Class">
                                <Option value="DETAIL">DETAIL</Option>
                                <Option value="CONTROL">CONTROL</Option>
                                <Option value="SUMMARY">SUMMARY</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Normal Balance"
                            name="normalBalance"
                            rules={[{ required: true }]}
                        >
                            <Select placeholder="Select Balance">
                                <Option value="DEBIT">DEBIT</Option>
                                <Option value="CREDIT">CREDIT</Option>
                            </Select>
                        </Form.Item>
                    </div>

                    <Form.Item
                        label="Parent Account Code"
                        name="parentAccountCode"
                    >
                        <Input placeholder="e.g. 10000000" />
                    </Form.Item>

                    <Form.Item
                        label="Description"
                        name="description"
                        rules={[{ required: true, message: 'Description is required' }]}
                    >
                        <Input.TextArea rows={3} placeholder="Enter account description" />
                    </Form.Item>

                    <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            style={{
                                height: 48,
                                background: '#FF4B01',
                                border: 'none',
                                fontWeight: 600,
                                borderRadius: 8
                            }}
                        >
                            Create Account
                        </Button>
                    </Form.Item>
                </Form>
            </Wrapper>
        </Modal>
    );
};

export default CreateGLAccountModal;
